﻿import { GUTTER_SIZE } from "@/enums";
import { projectMilestoneType } from "@/propTypes";
import { useProjectContext } from "@/providers";
import { Col, Row, Typography } from "antd";
import { object, string } from "prop-types";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { AssignedUserSelector, NotApplicableToggle } from "./components";

const { Title } = Typography;

export const ProjectLeaderRoleDisplay = ({ role, form, status }) => {
  const intl = useIntl();

  const [disableRole, setDisableRole] = useState(false);

  const { project: { projectLeaders } = {} } = useProjectContext();

  useEffect(() => {
    setDisableRole(!!role.isNotApplicable);
  }, [role.isNotApplicable]);

  const handleToggle = (checked) => {
    if (checked) {
      form.setFieldsValue({
        [role.id]: { isNotApplicable: checked },
      });
    }

    setDisableRole(checked);
  };

  return (
    <>
      <Title level={5}>
        {intl.formatMessage({ id: "project.approvers.projectLeader" })}
      </Title>
      <Row gutter={GUTTER_SIZE.small} wrap={false} align="middle">
        <Col flex="auto">
          <AssignedUserSelector
            disabled={disableRole}
            projectLeaders={projectLeaders}
            role={role}
          />
        </Col>
        <Col style={{ minWidth: 65 }}>
          {role.canSetNotApplicable && (
            <NotApplicableToggle
              roleId={role.id}
              value={role.isNotApplicable}
              status={status}
              handleToggle={handleToggle}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

ProjectLeaderRoleDisplay.propTypes = {
  role: projectMilestoneType.isRequired,
  form: object,
  status: string,
};
